<template>

  <div class="footer-menu-main">
    <ul class="menu">
      <li class="menu__item">
        <router-link to="/">
          <span>{{ t("main_page") }}</span>
        </router-link>
      </li>
      <li class="dot"></li>
      <li class="menu__item">
        <router-link to="/privace-policy">
          <span>{{ t('privacy_policy') }}</span>
        </router-link>
      </li>
      <li class="dot"></li>
      <li class="menu__item">
        <router-link to="/contact">
          <span>{{ t('contact') }}</span>
        </router-link>
      </li>
    </ul>
  </div>

</template>

<script>
import View from "@/views/View.vue"

export default {
  name: "FooterMenuMain",
  extends: View
}
</script>

<style scoped lang="scss">

.footer-menu-main {

}

.menu {
  list-style: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;

  @media screen and (max-width: 767px) {
    flex-direction: column;
  }

  &__item {

    & > a {
      cursor: pointer;
      transition: all 0.25s ease 0s;
      color: rgb(100, 100, 100);

      &:hover {
        color: rgb(73, 78, 155);
      }
    }
  }
}

.dot {
  width: 4px;
  height: 4px;
  background-color: rgb(100, 100, 100);
  border-radius: 100%;

  @media screen and (max-width: 767px) {
    display: none;
  }
}

html.contrast {

  & .menu {

    &__item {

      & > a {
        color: #d2d2d2;

        &:hover {
          color: gold;
        }
      }
    }
  }

  & .dot {
    background-color: #d2d2d2;
  }
}

</style>